import { drawRoundRect } from './utils';

const SCALE = window.devicePixelRatio || 1;
const FRAME_BORDER_RADIUS = 30;
const STROKE_WIDTH = 18;

class Frame {
  constructor(container) {
    this.strokeWidth = STROKE_WIDTH * SCALE;
    this.complementaryColor = '';
    this.color = '';
    this.titleColor = '';
    this.container = container;
    this.canvas = document.createElement("canvas");
    this.titleElement = document.getElementById("main-title");
    this.canvas.classList.add("frame");
    this.container.appendChild(this.canvas);
    this.canvasContext = this.canvas.getContext("2d");
    this.started = false;
  }

  start() {
    this.started = true;
    this.draw();
    this.canvas.classList.add("shown");
  }

  draw() {
    // TODO : Audio reactive animation ?
    this.canvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.canvasContext.beginPath();
    this.canvasContext.strokeStyle = this.color;
    this.canvasContext.lineWidth = this.strokeWidth;
    drawRoundRect(this.canvasContext, 0, 0, this.width * SCALE, this.height * SCALE, FRAME_BORDER_RADIUS * SCALE);
    this.canvasContext.stroke();
    this.canvasContext.fillStyle = this.color;
    const rw = this.strokeWidth / 2;
    this.canvasContext.fillRect(0, 0, rw, rw);
    this.canvasContext.fillRect(this.width * SCALE - rw, 0, rw, rw);
    this.canvasContext.fillRect(this.width * SCALE - rw, this.height * SCALE - rw, rw, rw);
    this.canvasContext.fillRect(0, this.height * SCALE - rw, rw, rw);
  }

  changeColor(color, complementaryColor) {
    this.complementaryColor = complementaryColor;
    this.color = color;
    this.draw();
  }

  changeTitleColor(color) {
    this.titleColor = color;
    this.titleElement.style.color = color;
  }

  menuChange(isOpened) {
    if (isOpened) {
      this.titleElement.style.color = '#ffffff';
    } else if (this.titleColor.length) {
      this.changeTitleColor(this.titleColor);
    }
  }

  resize(width, height) {
    this.width = width;
    this.height = height;
    this.canvas.width = this.width * SCALE;
    this.canvas.height = this.height * SCALE;
    this.canvas.style.width = `${this.width}px`;
    this.canvas.style.height = `${this.height}px`;
    this.draw();
  }
}

export { Frame };
